import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const initializeEnrollmentContract = createAsyncThunk<string, string, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/initializeEnrollmentContract",
  async (enrollmentId: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.initializeEnrollmentContract(enrollmentId);
  },
);

export const resetInitializeEnrollmentContract = createAction("educationalAdvisor/resetInitializeEnrollmentContract");
